/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { openThirdPage } from '@/api/native/utils';
import { customServiceUrl } from '@/constant';
import RouterHelper from '@/shared/utils/routerHelper';
import { Component, Vue } from 'vue-property-decorator';
import { StateType as HomeStateType } from '@/views_v2/home/types';
import { namespace } from 'vuex-class';

const HomeStore = namespace('home');
const style = require('./index.module.scss');

@Component
export default class CreditBlocked extends Vue {
  @HomeStore.State aliProductStatus!: HomeStateType['aliProductStatus'];

  private get infos(): string[] {
    const { dialogText } = this.aliProductStatus;
    return [
      '您的资料已填写完成',
      dialogText || '系统升级中，额度审批暂停，造成不便敬请谅解，恢复后可重新一键提交审批',
    ];
  }

  private callCustomService() {
    this.$ubtPageButton(
      'finance_aliCreditBlocked_confirmCallService',
      'status',
      this.aliProductStatus.status || '',
    );
  }

  private onBackHome() {
    this.$ubtPageButton(
      'finance_aliCreditBlocked_backHome',
      'status',
      this.aliProductStatus.status || '',
    );
    RouterHelper.backHome();
  }

  private onClickCallService() {
    openThirdPage(customServiceUrl);
    this.$ubtPageButton(
      'finance_aliCreditBlocked_callService',
      'status',
      this.aliProductStatus.status || '',
    );
  }

  private onCancelCall() {
    this.$ubtPageButton(
      'finance_aliCreditBlocked_cancelCallService',
      'ststus',
      this.aliProductStatus.status || '',
    );
  }

  private render() {
    return (
      <div class={style.creditBlocked}>
        <div class={style.infos}>
          {this.infos.map((info) => (
            <span>{info}</span>
          ))}
        </div>

        <div class={style.buttons}>
          <div
            class={style.backHome}
            onClick={this.onBackHome.bind(this)}
          >回到首页</div>
          <div
            class={style.callService}
            onClick={this.onClickCallService.bind(this)}
          >联系客服</div>
        </div>

      </div>
    );
  }
}
